import Select from '../plugins/Select';

$(function () {

    $('[data-update]').change(function () {

        const val = $(this).val(),
            update = $(this).data('update'),
            form = $(this).parents('form').eq(0),
            input = form.find(`[name="${update}"]`);

        if (val || typeof val === 'number') {

            $.ajax({
                type: 'POST',
                url: `/ajax/update/${update}/`,
                data: {val},
                dataType: 'json',
                success: data => {
                    input.html(data.html).removeAttr('disabled');
                    Select.get(form).update(input);
                }
            });
        }
        else {
            input.html('').attr('disabled', 'disabled');
            Select.get(form).update(input);
        }

    });

});